import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Header from './components/Header';
import HeaderAll from './components/HeaderAll';
import Home from './components/Home';
import Music from './components/Music';
import Booking from './components/Booking';
import Events from './components/Events';
import Testimonial from './components/Testimonial';
import Join from './components/Join';
import About from './components/About';
import Donation from './components/Donation';
import SingleDonation from './components/SingleDonation';
import DonationResult from './components/DonationResult';
import Mentorship from './components/Mentorship';
import Support from './components/Support';
import Register from './components/Register';
import InviteFriend from './components/InviteFriend';
import Footer from './components/Footer';
import VisitTracker from './VisitTracker';


function App() {
  return (
    <Router>
      <VisitTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/music" element={<><HeaderAll /><Music /></>} />
        <Route path="/booking" element={<><HeaderAll /><Booking /></>} />
        <Route path="/events" element={<><HeaderAll /><Events /></>} />
        <Route path="/testimonial" element={<><HeaderAll /><Testimonial /></>} />
        <Route path="/join" element={<><HeaderAll /><Join /></>} />
        <Route path="/about" element={<><Header /><About /></>} />
        <Route path="/donation" element={<><HeaderAll /><Donation /></>} />
        <Route path="/donation/result" element={<><HeaderAll /><DonationResult /></>} />
        <Route path="/singledonation" element={<><HeaderAll /><SingleDonation /></>} />
        <Route path="/Mentorship" element={<><HeaderAll /><Mentorship /></>} />
        <Route path="/volunteer" element={<><HeaderAll /><Support /></>} />
        <Route path="/support" element={<Navigate to="/volunteer" replace />} />
        <Route path="/register" element={<><HeaderAll /><Register /></>} />
        <Route path="/invite" element={<><HeaderAll /><InviteFriend /><Footer /></>} />
        {/* Add other routes here */}
      </Routes>
    </Router>
  );
}

export default App;
